<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import SlideMenuComponent from "@/components/SlideMenuComponent.vue";

export default {
  name: "BenefitView",
  components: {SlideMenuComponent, HeaderComponent},
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {
  },
  unmounted() {
  }
}
</script>

<template>
  <div>
    <HeaderComponent/>
    <SlideMenuComponent/>
    <div class="index">
      <div class="section6">
        <div class="content">
          <div class="title">{{ $t("benefitTitle") }}</div>
          <div class="tablelist">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" class="">
              <tr>
                <th>{{ $t("benefitType") }}</th>
                <th>{{ $t("revenueQuantity") }}</th>
                <th>{{ $t("time") }}</th>
              </tr>
              <tr v-show="false">
                <td>{{ $t("miningRewards") }}</td>
                <td>1234.22</td>
                <td>03/08/25 17:22</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>